module.exports = __webpack_public_path__ + "media/images/fuda01-d87fd8825416beabff739e4ef67313b7.jpg";